export const menuTitle: Record<string, any> = {
    '/': 'AI报告审核',
    '/login': '登录',
    '/dashboard': '首页',
    '/review-history': '审核历史',
    '/review-rules': '审核规则',
    '/audit-detail': '审核详情'
}